import React, {
  useCallback,
  useState,
  useEffect,
  useRef,
  useMemo,
} from "react";
import { InputField } from "../../components/input-field";
import { useHistory } from "react-router-dom";
import { PinModal } from "../../components/pin-modal/PinModal";
import { useDispatch, useSelector } from "react-redux";
import { useDebounce } from "use-debounce/lib";
import { Footer } from "../../components/footer/Footer";
import { actions as scanResultActions } from "../../pages/redux/ScannerDetailsRedux";
import { useDispatchRfidQrResult } from "../scanner-validator/hook/useDispatchRfidQrResult";
import { useBreakPoint } from "../../hook/useBreakPoint";
export const CounterRFIDPage = () => {
  const [rifdValue, setRfidValue] = useState("");
  const [error, setError] = useState(null);
  const [showCode, setShowCode] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isStartScanning, setIsStartScanning] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const scanner = useSelector((state) => state.scanner.scanner);
  const [debounceRfid] = useDebounce(rifdValue, 300);
  const listnerRef = useRef(null);
  const selectedEvent = useSelector((state) => state.scanner.selectedEvent);
  const { getData } = useDispatchRfidQrResult();
  const { down } = useBreakPoint();
  const isMobile = useMemo(() => {
    return down("sm");
  }, [down]);
  useEffect(() => {
    document.getElementById("mainBox").style.overflowY = "hidden";
    document.body.style.overflowY = "hidden";
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsStartScanning(true);
      clearTimeout(timer);
    }, 200);

    if (listnerRef.current) {
      document.getElementById("rfid-input").focus();
      listnerRef.current.addEventListener("click", () => {
        document.getElementById("rfid-input").focus();
      });
      listnerRef.current.addEventListener("touchend", () => {
        document.getElementById("rfid-input").focus();
      });
    }
  }, [listnerRef]);

  useEffect(() => {
    dispatch(scanResultActions.clearResult());
  }, [dispatch]);

  const handleChangeInput = useCallback(
    (event) => {
      if (isStartScanning) setRfidValue(event.target.value);
    },
    [isStartScanning]
  );

  useEffect(() => {
    if (!selectedEvent) {
      history.replace("/events");
    }
  }, [history, selectedEvent]);

  useEffect(() => {
    if (isSubmitting) {
      setError(null);

      if (scanner && scanner.data && debounceRfid && selectedEvent) {
        const _data = {
          ticketCode: debounceRfid.trim(),
          isCheckedIn: true,
          gateCode: scanner.data.code.trim(),
          eventCode: selectedEvent.code.trim(),
          rfid: true,
        };
        getData({
          type: "rfid",
          dataBody: _data,
          debounceCode: debounceRfid.trim(),
          setIsSubmitting,
          setResult: () => setRfidValue(""),
          history: history,
          goto: "/counter-result",
        });
      }
    }
  }, [
    isSubmitting,
    debounceRfid,
    dispatch,
    history,
    scanner,
    selectedEvent,
    getData,
  ]);

  const handleCheckRFID = useCallback(async () => {
    setIsSubmitting(true);
  }, []);

  const handlePinSubmit = useCallback(() => {
    setTimeout(() => {
      if (scanner && scanner.data) {
        history.push("/events");
      }
    }, 500);
  }, [history, scanner]);

  useEffect(() => {
    if (debounceRfid && debounceRfid !== "") {
      handleCheckRFID();
    }
  }, [debounceRfid, handleCheckRFID]);

  return (
    <>
      <div
        ref={listnerRef}
        className="position-absolute top-50 start-50 translate-middle w-100"
        style={{
          height: "100%",
        }}
      >
        <div
          className="row mx-0 padding position-absolute start-50 translate-middle mb-5"
          style={{
            top: "48%",
          }}
        >
          <div className="d-flex flex-column gap-2">
            <div className="text-center mb-5">
              <svg
                fill="white"
                viewBox="18 18.7 866.2 246.4"
                width={isMobile ? "200px" : "300"}
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="m360.5 19.5c-.5.1-4.4.8-8.5 1.5-18.4 3-30.9 8.8-45.7 21.5-9.7 8.2-99.2 97.8-98.7 98.7.3.4 15.5.8 33.8.8h33.3l22.4-21.8c12.3-11.9 26.2-25.5 30.9-30 12.3-12.1 20.1-17.9 28.4-20.9 11.9-4.4 14.6-4.5 113.8-5.2l94.7-.6 21.6-21.4c11.8-11.8 21.5-21.8 21.5-22.3 0-.7-245.1-1.1-247.5-.3zm198.6 60.2c-33 33.3-59.8 61-59.5 61.5.3.4 17 .8 37.2.8h36.7l60.8-60.8c33.4-33.4 60.7-61 60.7-61.5 0-.4-17.1-.7-37.9-.7h-37.9z" />
                <path d="m379 73c-14.4.7-21.9 3-30.5 9.4-5.9 4.3-59.5 57.8-58.9 58.8.3.4 14.3.8 31.1.8h30.6l11.6-11.3c17.3-17 10.2-15.7 87.5-15.7h63.1l20.3-20.2c11.4-11.5 20-20.8 19.8-21.5-.4-1-16.6-1.3-81.8-1.1-44.7.1-86.5.4-92.8.8zm228.5 54.9c-.3.5.4 1.2 1.5 1.6 1.7.5 2 1.5 2 6.2 0 3.9.4 5.3 1.3 5 .7-.2 1.2-2.2 1.2-4.9 0-2.4.6-5.1 1.2-6 .7-.8 1-1.8.6-2.1-1-1-7.1-.8-7.8.2zm12.5 6.1c0 5.6.3 7 1.5 7 .8 0 1.5-.9 1.5-1.9 0-1.1.5-2.3 1-2.6 1.4-.9 1.3-6.8-.2-8.3-2.8-2.8-3.8-1.3-3.8 5.8zm11.7-6.3c-.2.5-1 2.5-1.6 4.5-.7 2.1-1.9 3.8-2.7 3.8s-1.4 1-1.4 2.4c0 3.5 1.8 4.2 3 1.2 1.1-3.1 2.6-3.3 3.5-.6 1.1 3.6 2.1 1.3 2.3-5.4.1-5.1-.2-6.6-1.3-6.6-.7 0-1.6.3-1.8.7zm-611.9 39.3c-1.7 1-1.8 4.4-1.8 47.1 0 29.8.4 46.7 1 48 .9 1.5 2.2 1.9 7 1.9 3.3 0 6.1-.1 6.2-.3.1-.1.4-8.5.7-18.7l.6-18.5 22-.6c17.5-.5 22.9-.9 26.5-2.3 6-2.3 10.5-5.9 13.8-10.9 2.6-3.9 2.7-4.6 2.7-16.6s-.1-12.8-2.8-16.8c-3.2-5-8.8-8.8-16.1-11-6.4-1.9-57-3-59.8-1.3zm55.9 6.5c7.2 3 7.8 4.8 7.8 23.3v16.4l-3.7 3.4-3.8 3.4h-43v-23.3c0-12.9.3-23.7.7-24 .3-.4 9.1-.7 19.4-.7 14.7 0 19.7.3 22.6 1.5zm169.5-6.2c-.6.7-1.2 5.1-1.4 9.7l-.3 8.5-20.5.6c-20.3.5-20.6.6-25.9 3.5-6.5 3.5-10.8 8.6-13.3 15.6-2.7 7.9-2.6 32.7.3 39.9 2.7 7.1 5.3 10.5 10.2 13.6 7 4.4 13.1 5.2 38.8 5.3 20.7 0 23.8-.2 24.3-1.6.3-.9.6-22.4.6-47.8 0-34.6-.3-46.5-1.2-47.4-1.6-1.6-10.3-1.5-11.6.1zm-3.4 25.3 2.2.6v31.4c0 30-.1 31.4-1.9 32.4-2.6 1.3-27.1 1.1-34.1-.3-4.6-1-5.8-1.8-8.2-5.2l-2.7-4-.1-22.6v-22.6l3-4.1c3-4.1 4.4-4.8 11-5.5 6.2-.7 28.4-.7 30.8-.1zm88.3-24.7c-.6 1.1-1.1 5.5-1.1 9.9v7.9l-20.2.5c-18.7.4-20.7.6-24.8 2.7-6.1 3.1-9.7 6.6-12.8 12.6-2.6 4.9-2.7 5.4-2.7 23 0 20 .8 23.8 6.9 30.3 7.3 7.9 14.9 9.4 45.1 9l23-.3v-97l-6.2-.3c-5.3-.3-6.3 0-7.2 1.7zm-1.6 25.1c.8 1.3.7 62.8 0 64.1-.8 1.3-25.4 1.1-33.1-.2-11.2-1.9-13.4-7.3-13.4-32.3 0-24.1 2.6-30.4 13.3-31.7 8.7-1 32.5-1 33.2.1zm184-25.8c-.3.7-.4 22.7-.3 48.8l.3 47.5 5.7.3c7.7.4 7.9-.2 7.7-18.8 0-8.2.2-15.4.6-16.1 1.3-2 10.3-.3 12.9 2.3 1.2 1.3 6.4 7.9 11.5 14.8 14.2 18.9 13.1 18 21.8 18h7.4l-1.5-2.7c-.8-1.6-3.3-5.1-5.6-7.8-2.2-2.8-6.7-8.4-10-12.5-3.2-4.1-7.3-9.1-8.9-11-1.7-1.9-3.1-4.3-3.1-5.4 0-1.6 4-7.5 7.7-11.4.7-.7 3.4-4.1 6-7.5s5-6.4 5.3-6.7 2.2-2.7 4.3-5.3c5.1-6.3 4.5-7.7-3.3-7.7-5.3 0-6.3.3-8.3 2.6-1.2 1.5-2.7 3.2-3.2 3.8-.6.6-4.9 6-9.5 12.1-11.7 15.3-12.2 15.7-17.9 16.3-3 .3-5.1 0-5.5-.7-.4-.6-.7-12.3-.6-26 .1-28.6.2-28.1-8.1-28.1-3 0-5.1.5-5.4 1.2zm124 .4c-8.9 1.9-14.5 4.6-19.4 9.3-8.2 7.9-11.1 18.3-11 39.1.1 20.3 2.5 28.7 10.8 37 9 9 19.5 11.3 49.1 10.8l18.5-.3.3-2.7c.2-1.6.2-2.9 0-3-.2 0-11.6-.4-25.4-.7l-25.1-.6-3.6-2.8c-2.1-1.6-4.7-4.7-6-7-2.1-4.1-2.2-5.1-2.2-31.7 0-26.5.1-27.6 2.2-31.7 4.8-8.8 9.9-10.3 36.2-10.3 20.1 0 24.1-.6 24.1-3.5 0-.8-.9-1.9-1.9-2.5-3.1-1.6-38.2-1.1-46.6.6zm58.7-.8c-.9.7-1.2 11.1-1 48.8l.3 47.9h12v-97l-5-.3c-2.7-.1-5.6.2-6.3.6zm111 .4c-.9.9-1.2 12.8-1.2 47.4 0 25.4.3 46.9.6 47.8.5 1.4 3.6 1.6 24.3 1.5 31.7-.1 38.2-1.6 46.3-10.9 6.9-7.9 8-12.2 7.6-29.7-.3-14-.5-15.1-3.1-20.3-3.5-6.8-7.3-10.4-14.6-13.7-5.2-2.4-7-2.6-26.1-3.2l-20.5-.6-.3-8.5c-.2-4.6-.8-9-1.4-9.7-1.3-1.6-10-1.7-11.6-.1zm52.6 26.7c1.2.6 3.3 2.8 4.7 4.9 2.5 3.6 2.5 3.8 2.5 25.5 0 19.5-.2 22.2-1.9 25.6-2.6 5.1-3.6 5.7-10.5 7-7.6 1.4-30.1 1.4-32.7.1-1.8-1-1.9-2.4-1.9-32.5 0-29 .1-31.4 1.8-31.9 3.3-1 35.8.1 38 1.3zm-473.8-9.3c-14.2 2.4-19.3 4.6-24.5 10.6-5.5 6.5-7 13-7 29.8 0 18.3 1.6 24.2 8.5 31.1 3.4 3.4 6.3 5.2 11.3 6.8 6.1 2.1 8.3 2.2 21.5 1.9 16.6-.5 20.8-1.7 28.1-8.4 7.6-6.8 8.5-10.2 8.6-31.4 0-18.1-.1-18.6-2.6-23.5-4.5-8.5-10.3-12.9-19.9-15.3-5.1-1.2-20.2-2.3-24-1.6zm23 7c5.3 2.1 7.5 5.5 8.9 13.5 1.4 8.5 1.4 31.1 0 39.9-1 5.8-1.8 7.5-4.7 10.5l-3.5 3.5h-31.3l-3.1-2.8c-5.5-4.9-6.3-8.8-6.2-32 0-19.2.2-21 2.2-25.2 3.6-7.3 7.7-9 21.9-9 8.5 0 12.9.4 15.8 1.6zm-300.2-5c-1.3 1.2-.9 5.4.5 5.5.6 0 9.3 0 19.2-.1 23.1-.1 24 .4 15.2 7.7-3.4 2.9-8.4 7.3-11.2 9.8-2.7 2.5-9.6 8.7-15.2 13.6-17.6 15.6-20.8 21.6-16.4 31.2 3.9 8.4 9.7 9.7 44.6 9.7 16.9 0 26.6-.4 27-1s.6-14.7.6-31.3c0-31.4-.2-33.1-4.3-38.6-1-1.3-3.5-3.3-5.5-4.4-3.5-2-5.7-2.2-28.8-2.5-13.7-.2-25.3 0-25.7.4zm50 43.5-.3 27.4-16.5.3c-24.9.5-30-1.3-30-10.4 0-3.3.9-4.6 9.3-12.8 8.4-8.3 22-20.9 32.2-30 2.2-1.9 4.3-3.1 4.8-2.7.4.4.6 13.1.5 28.2zm308.2-43.1c-9.5 1.5-16.3 6.4-21.1 15.1-2.3 4.2-2.4 5.2-2.4 22.9 0 17.6.1 18.7 2.4 22.8 7 12.7 15.8 16.1 41.8 16.2 15.4 0 16.2-.1 16.8-2 1.4-4.3-.5-4.8-20.5-5.2l-18.9-.3-2.9-2.8c-4-3.8-5.2-10.5-5.2-28.7 0-19 1.2-25.1 5.7-29l3.4-3h18.3c15.5 0 18.6-.2 19.7-1.6.9-1.1 1-2 .2-3.2-.9-1.5-3.3-1.7-16.9-1.8-8.7-.1-17.9.2-20.4.6zm253.7-.3c-.4.3-.7 13.1-.7 28.3 0 32.6.6 35.7 8.4 42.6 6.4 5.6 11.6 6.4 41.4 6.4 20.9 0 24.1-.2 24.6-1.6.3-.9.6-17.9.6-37.8 0-26.8-.3-36.5-1.2-37.4-1.7-1.7-11.3-1.5-12.7.1-.7.9-1.2 12.3-1.3 35.3l-.3 33.9h-39.5l-2.7-2.8-2.8-2.7-.2-31.7c-.2-24.2-.6-31.9-1.5-32.5-1.6-.9-11.2-1.1-12.1-.1z" />
              </svg>
            </div>
            <div>
              <div className="d-flex justify-content-center">
                <div
                  className="d-flex flex-column justify-content-center"
                  style={{
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="d-flex text-primary"
                    style={{
                      fontSize: isMobile ? "2.5em" : "4em",
                    }}
                  >
                    <div className="letter">W</div>
                    <div className="letter">E</div>
                    <div className="letter">L</div>
                    <div className="letter">C</div>
                    <div className="letter">O</div>
                    <div className="letter">M</div>
                    <div className="letter">E</div>
                  </div>
                </div>
              </div>
              <div className="mt-5 w-100">
                <InputField
                  disabled={isSubmitting}
                  id="rfid-input"
                  type="text"
                  value={rifdValue}
                  placeholder="RFID Code"
                  onChange={(e) => handleChangeInput(e)}
                />

                {error && (
                  <p
                    className="text-center mt-2"
                    style={{
                      color: "red",
                    }}
                  >
                    {error}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <PinModal
        show={showCode}
        handleClose={() => {
          document.getElementById("rfid-input").focus();
          setShowCode(false);
        }}
        onSubmit={handlePinSubmit}
      />

      {scanner && scanner.data && selectedEvent && (
        <Footer
          path={`${scanner.data.name}/${selectedEvent.name}`}
          onClick={() => {
            setTimeout(() => {
              setShowCode(true);
            }, 500);
          }}
        />
      )}
    </>
  );
};

export const decimalToHexa = (number) => {
  return parseInt(number).toString(16);
};

export const hexaDecimalToDeicmal = (code) => {
  return parseInt(code, 16);
};
